import { Box, Typography } from "@mui/material"
import { useEffect, useState } from "react"
import AnalyticsIcon from '@mui/icons-material/Analytics'
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch'
import { AnimatePresence, motion } from "motion/react"

interface IntroOverlayProps {
    onFinish: () => void
}

const slides = [
    {
        key: 'welcome',
        content: (
            <Box>
                <RocketLaunchIcon sx={{ fontSize: 64, mb: 2 }} />
                <Typography variant="h4">Welcome to Staturday</Typography>
                <Typography color="text.secondary">
                    This is something we're building together — just for fun, just for us.
                </Typography>
            </Box>
        ),
    },
    {
        key: 'charts',
        content: (
            <Box>
                <AnalyticsIcon sx={{ fontSize: 48, mb: 2 }} />
                <Typography variant="h5" gutterBottom>Just for laughs</Typography>
                <Typography color="text.secondary"> It's all in good fun. Don't take anything too seriously. We certainly don't.</Typography>
            </Box>
        ),
    },
    {
        key: 'features',
        content: (
            <Box>
                <Typography variant="h5" mt={2}>Just Us</Typography>
                <Typography color="text.secondary">
                    A little dashboard. Made with love, shared with friends.
                </Typography>
            </Box>
        ),
    },
    {
        key: 'final',
        content: (
            <Box>
                <Typography variant="h4" gutterBottom>Let's Jump In</Typography>
                <Typography>Into the glazing stats</Typography>
            </Box>
        ),
    },
]

const DURATION_MS = 4000

export const IntroOverlay = ({ onFinish }: IntroOverlayProps) => {
    const [step, setStep] = useState(0)

    useEffect(() => {
        const timeout = setTimeout(() => {
            if (step < slides.length - 1) {
                setStep((prev) => prev + 1)
            } else {
                localStorage.setItem('introSeen', 'true')
                onFinish()
            }
        }, DURATION_MS)

        return () => clearTimeout(timeout)
    }, [step, onFinish])

    return (
        <AnimatePresence mode="wait">
            <motion.div
                key="intro-overlay"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.5 }}
                style={{
                    position: 'fixed',
                    inset: 0,
                    background: 'linear-gradient(145deg, #0d1117, #161b22)',
                    color: '#ffffff',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 9999,
                    padding: '2rem',
                }}
            >
                <AnimatePresence mode="wait">
                    <motion.div
                        key={slides[step].key}
                        initial={{ opacity: 0, y: 40 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -40 }}
                        transition={{ duration: 0.6 }}
                        style={{ textAlign: 'center' }}
                    >
                        {slides[step].content}
                    </motion.div>
                </AnimatePresence>
            </motion.div>
        </AnimatePresence>
    )
}